import { RootState } from '../store';
import { SpecificLead } from './types';
import { useAppSelector } from '../../app/useAppSelector';
import { LEAD_TYPE } from '../../pages/leads-management/models/ILead';

export const useSelectedLead = (): SpecificLead | undefined => {
    return useAppSelector((state: RootState) => state.leadsManagement.selectedLead);
  };

  export const useAudioFile = (): string => {
    return useAppSelector((state: RootState) => state.userManagement.resource);
  };

   export const useSelectedLeadType = (): LEAD_TYPE => {
    return useAppSelector((state: RootState) => state.leadsManagement.leadType);
  };